<script setup lang="ts">
import type { IInvoiceContainer } from '@/types/rc/invoices'
import { formatCurrency } from '@/util/formatters'
import { Icon } from '@iconify/vue'

defineProps<{ containers?: IInvoiceContainer[] }>()
</script>

<template>
  <el-table :data="containers" :show-header="false" empty-text="No containers">
    <el-table-column prop="number" label="Number" />

    <el-table-column prop="total" label="Total">
      <template #default="{ row }">
        <span class="text-text-tertiary">Total:&nbsp;</span>{{ formatCurrency(row.total) }}
      </template>
    </el-table-column>

    <el-table-column prop="total_miners" label="Total Miners">
      <template #default="{ row }">
        {{ row.total_miners }}
        <span class="text-text-tertiary"> &nbsp;{{ row.total_miners === 1 ? 'miner' : 'miners' }} </span>
      </template>
    </el-table-column>

    <el-table-column>
      <div class="w-full flex justify-end">
        <Icon icon="ep:arrow-right-bold" />
      </div>
    </el-table-column>
  </el-table>
</template>
